import React from "react";
import "./PageHeader.css";
import BackButton from "../BackButton/BackButton";

export default function PageHeader({
  title,
  subtitle,
  icon,
  iconVariant = "green",
  rightContent,
  showBack = true,
}) {
  return (
    <header className="cmd-page-header">
      <div className="cmd-page-header__left">
        {showBack && <BackButton />}

        <div className="cmd-page-header__title-wrapper">
          {icon && (
            <div className={`cmd-page-header__icon cmd-page-header__icon--${iconVariant}`}>
              {icon}
            </div>
          )}

          <div>
            <h1 className="cmd-page-header__title">{title}</h1>
            {subtitle && (
              <p className="cmd-page-header__subtitle">{subtitle}</p>
            )}
          </div>
        </div>
      </div>

      {rightContent && (
        <div className="cmd-page-header__right">
          {rightContent}
        </div>
      )}
    </header>
  );
}